<div class="relative flex flex-col h-full w-full"
   *transloco="let t">
   <div id="chat-container" class="t-chat-container mb-auto w-full overflow-auto text-start p-5" aria-live="polite">
      @for (qanda of qandas; track qanda.id) {
         @if(!$first) {
            <div class="border border-gray-300 w-4/5 ms-[10%] my-8"></div>
         }
         <div #chat class="t-qanda me-2" [attr.id]="'qanda-' + $index" #scrollToMe>
            <app-question-and-answer [qanda]="qanda"></app-question-and-answer>
         </div>

      }
      @empty {
         <div class="t-qanda-empty text-center text-gray-400 mt-5">
            <span>{{ t('chat.answerplaceholder') }}</span>
            @if(shouldShowLoader) {
               <app-loader class="mt-2" height="16px"></app-loader>
            }
         </div>
      }
   </div>

   <div class="t-qanda-searchbox mt-5 text-center">
      <app-searchbox></app-searchbox>
   </div>
</div>
